import React from "react";
import { StoryNode } from "../../StoryBook/StoryData";
import {
    PropertyEditorCollapsableSection,
    PropertyEditorCollapsableSectionInterface,
} from "../PropertyEditorCollapsableSection";
import { PropertyEditorExpression } from "../PropertyEditorExpression";
import { PropertyEditorTypeSelection } from "../PropertyEditorTypeSelection";
import { PropertyEditorVariableSelection } from "../PropertyEditorVariableSelection";
import { getFilledDataDefinition } from "../../../rule-engine-core/Common/Data/DataTestData";
import { ExpressionConfiguration } from "../../../rule-engine-core/Expressions/ExpressionConfiguration";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { StateManager } from "../../../rule-engine-core/Common/StateManager";
import { ObserveState } from "../../StateManagement/ObserveState";

const datadef = getFilledDataDefinition();

class SectionData implements PropertyEditorCollapsableSectionInterface {
    editObject: { expression: ExpressionConfiguration; type: IDataDefinition; field: string | undefined } = {
        expression: new ExpressionConfiguration(),
        type: new StringDataDefinition(),
        field: undefined,
    };
    label: string = "Set Expression";
    startOpen: boolean = true;
    renderUI: () => JSX.Element = () => {
        return (
            <ObserveState
                listenTo={this.editObject}
                control={() => {
                    let resultType: IDataDefinition | null = null;
                    if (this.editObject.field) {
                        try {
                            resultType = DataUtilities.getFieldFromDataDefinitionByName(
                                datadef.fields,
                                this.editObject.field,
                            );
                        } catch (e) {}
                    }

                    return (
                        <>
                            <PropertyEditorTypeSelection
                                editObject={this.editObject}
                                propertyName="type"
                            />
                            <PropertyEditorVariableSelection
                                editObject={this.editObject}
                                inputDataFunction={() => datadef}
                                propertyName="field"
                                expectedType={this.editObject.type}
                                allowNew={true}
                            />
                            <PropertyEditorExpression
                                editObject={this.editObject}
                                inputDataFunction={() => datadef}
                                propertyName="expression"
                                resultType={resultType || this.editObject.type}
                            />
                        </>
                    );
                }}
            />
        );
    };

    updateCallback: () => void = () => {
        console.log("");
        StateManager.changed(this.editObject);
    };
}

export const PropertyEditorCollapsableSectionStories = [
    new StoryNode(
        () => {
            const params = new SectionData();
            return (
                <PropertyEditorCollapsableSection
                    {...params}
                    renderUI={params.renderUI}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Collapsable Section",
    ),
];
